<template>
  <v-main class="fill-height pa-2">
    <v-tabs
      class="fill-height elevation-1 idcs-main-list"
      background-color="idcs-main-list"
      v-model="seltab"
    >
      <v-tab v-for="(t,k) in tabs" :key="t" :href="'#'+t" :class="k<3?'secondary--text':''">{{$t("admin."+t)}}</v-tab>
      <v-tab-item v-for="t in tabs" :key="t" :value="t" class="pa-2 idcs-main-list">
        <component :is="t"></component>
      </v-tab-item>
    </v-tabs>
  </v-main>
</template>
<script>
import * as adminComponents from "@/components/admins";

export default {
  components: { ...adminComponents },
  name: "Admin",
  data() {
    return {
      seltab: "user",
      tabs: [
        "AdminUsers",
        "AdminCompanies",
        "AdminSmsapi",
        "AdminTasks",
        "AdminLists",
        "AdminEvents",
        "AdminFinances",
        "AdminTemplates",
        "AdminMessages"
      ]
    };
  }
};
</script>

<style>
</style>